import React from 'react'
import { Helmet } from 'react-helmet';

// Page content
import OceanContent from "../../pagecontent/ts/oceanContent";

export default function OceanPage() {
  return (
    <div>
        <Helmet>
            <title>海洋氣象 | 專業氣象 Professional Meteorology</title>
        </Helmet>
        <div className='' id=''>
            <OceanContent />
        </div>
    </div>
  )
}
